import React from 'react';

/**
 * HealthScoreCard — renders the financial health ring + breakdown bars.
 * Pure display; receives pre-computed score object from Dashboard.
 */
export function HealthScoreCard({ health }) {
  const healthColor =
    health.score >= 85
      ? 'var(--grn)'
      : health.score >= 70
        ? '#6bcb77'
        : health.score >= 50
          ? 'var(--ylw)'
          : health.score >= 30
            ? 'var(--pnk)'
            : 'var(--red)';

  const healthLabel =
    health.score >= 85
      ? 'Excellent 🌟'
      : health.score >= 70
        ? 'Great 💪'
        : health.score >= 50
          ? 'Good 👍'
          : health.score >= 30
            ? 'Fair 📈'
            : 'Needs Work 🔧';

  const circ = 2 * Math.PI * 30; // r=30

  return (
    <div className="card cp" style={{ marginBottom: 12 }}>
      <div className="st">❤️ Financial Health Score</div>
      <div className="hs-wrap">
        <div className="hs-ring">
          <svg width="80" height="80" viewBox="0 0 80 80">
            <circle cx="40" cy="40" r="30" fill="none" stroke="var(--bdr)" strokeWidth="8" />
            <circle
              cx="40"
              cy="40"
              r="30"
              fill="none"
              stroke={healthColor}
              strokeWidth="8"
              strokeDasharray={circ}
              strokeDashoffset={circ * (1 - health.score / 100)}
              strokeLinecap="round"
              style={{ transition: 'stroke-dashoffset .8s cubic-bezier(.4,0,.2,1)' }}
            />
          </svg>
          <div className="hs-num">
            <div className="hs-score" style={{ color: healthColor }}>
              {health.score}
            </div>
            <div className="hs-max">/100</div>
          </div>
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: healthColor, marginBottom: 8 }}>
            {healthLabel}
          </div>
          <div className="hs-bars">
            {[
              ['Budget', health.budgetScore, 'var(--ylw)'],
              ['Savings', health.savScore, 'var(--grn)'],
              ['Emerg. Fund', health.efScore, 'var(--blu)'],
              ['Debt', health.debtScore, 'var(--pnk)'],
            ].map(([l, v, c]) => (
              <div key={l} className="hs-bar-row">
                <span className="hs-bar-lbl">{l}</span>
                <div className="hs-bar-track">
                  <div
                    className="hs-bar-fill"
                    style={{ width: (v / 25) * 100 + '%', background: c }}
                  />
                </div>
                <span className="hs-bar-val" style={{ color: c }}>
                  {v}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div style={{ fontSize: 10, color: 'var(--mut)' }}>
        25 pts each: budget adherence · savings rate · emergency fund · debt progress
      </div>
    </div>
  );
}
